export default "__VITE_ASSET__BfdCnjyK__"